


























import { Vue, Component, Ref, Watch } from 'vue-property-decorator'
import store from 'src/assets/store'
import TopMenu from 'src/components/attendee/layout/TopMenu.vue'
import ActivityDashboard from 'components/presenter/layout/ActivityDashboard.vue'
import api from 'src/assets/api/gql'
import AttendeeIndex from 'src/graphql/attendee/AttendeeIndex.gql'
import { Session, ForumTopic } from 'src/graphql/types'

@Component({
  components: {
    TopMenu,
    ActivityDashboard
  }
})
export default class LayoutsAttendee extends Vue {
  top = true
  rightDrawerShowing = false

  created () {
    store.setProfile('ATTENDEE')
  }

  async activityLoad () {
    const { data: { attendeeComingSessions: { nodes: sessions }, attendeeForumTopicsRecent: { nodes: forumTopics } } } = await api.query({
      query: AttendeeIndex,
      variables: {
        days: 7,
        timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
        first: 10
      }
    })
    return { sessions, forumTopics }
  }

  activitySessionUrl (session: Session) {
    return session.topic ? `/attendee/${session.topic.id}/session/${session.id}` : '/attendee/'
  }

  activityForumTopicUrl (forumTopic: ForumTopic) {
    return `/attendee/${forumTopic.courseId}/forum/${forumTopic.id}`
  }
}
